const html = require("./html/asnDetailRowsReviewView.html");
import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide, handleDisplayFor} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import AsnStore from "../../../stores/AsnStore";
import AsnDetailRowReviewView from "./AsnDetailRowReviewView";

const elementsMap = {
  asnDetailRowsChildrenReviewEntry: ".shipping-asn-details-rows-children-review-entry-point",
  casePalletTitle: ".case-pallet-title"
}
 
export default function AsnDetailRowsView(_unused, {
  getAsn,
  getAsnDetailGroups,
  isPallet
}){
  const self = this;
  self._element = $();
  const els = {};
  let asnDetailRowReviewViews = [];

  self.init = function(){
    render();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  function setWidgets(){

  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    updateSelf();
    updateChildren();
  }

  function updateSelf(){
    // No self inputs
    updateCasePalletLabel();
  }

  function updateChildren(){
    unbindAll(asnDetailRowReviewViews);
    asnDetailRowReviewViews = renderAsnDetailRowReviewViews();
    els.asnDetailRowsChildrenReviewEntry.html(extractElements(asnDetailRowReviewViews));
  }

  function updateCasePalletLabel(){
    let text = "Case";
    if(isPallet()){
      text = "Pallet";
    }
    els.casePalletTitle.text(text);
  }



  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", update);
    AsnDetailStore.bindListener("asn_details:add", update);
    AsnDetailStore.bindListener("asn_details:remove", update);
    AsnStore.bindListener("asns:change", updateSelf);
  }

  self.unbindListeners = function(){

  }


  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    update();
    bindStores();
  }


  function renderAsnDetailRowReviewViews(){
    return _(getAsnDetailGroups()).map((asnDetailGroup, rowIdx)=>{
      // get the first asnDetail in the Pallet/case,
      // as all these values should be the same for the given
      // AsnDetailRowView
      const asnDetail = asnDetailGroup[0];
      const asnDetailRowReviewView = new AsnDetailRowReviewView(asnDetail, {
        rowIdx,
        isPallet
      });
      asnDetailRowReviewView.init();
      return asnDetailRowReviewView;
    });
  }

}


// WEBPACK FOOTER //
// ./src/pages/asns/ReviewTab/AsnDetailRowsReviewView.js